import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Stack,
  MenuItem,
  IconButton,
  Grid,
  Typography,
  InputAdornment
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Selector from "../../../components/Selector";

const initialForm = {
  initial_symbol: "DOP",
  symbol: "",
  cambio: 0,
};

export default function CrearMonedaDialog({ open, onClose }) {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});

  

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setErrors((prev) => ({ ...prev, [e.target.name]: "" }));
  };

  const validate = () => {
    let newErrors = {};
    if (!form.initial_symbol) newErrors.initial_symbol = "Simbolo inicial es requerido";
    if (!form.symbol) newErrors.symbol = "Simbolo es requerido";
    if (!form.cambio) newErrors.cambio = "Cambio es requerido";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) {
      return;
    }   

    
    const url = `${process.env.REACT_APP_SERVER_URL}/api/monedas`;
    
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        },
        body: JSON.stringify({
          initial_symbol:form.initial_symbol,
          symbol:form.symbol,
          cambio:form.cambio,
          idcompany:localStorage.getItem('idcompany'),
          creado_por:localStorage.getItem('id')
        })
      });

      const text = await response.text();
      try {
        const data = JSON.parse(text);
        if (!response.ok) {
          throw new Error(data.error || 'Error al crear moneda');
        }
        onClose()
      } catch (e) {
        throw new Error('Respuesta no es JSON: ' + text);
      }
    } catch (error) {
      setErrors(prev => ({...prev, general: error.message || 'Error desconocido'}));
      throw error;
    }


  };

  

  const handleClose = () => {
    setForm(initialForm);
    setErrors({});
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>
        Agregar Moneda
        <Typography variant="body1" color="text.secondary" textAlign={"left"} sx={{mt:1}}>Agregar una moneda a la empresa</Typography>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2} sx={{ mt: 1 }}>
            <Grid container spacing={2}>
                <Grid item size={12}>
                    <Selector placeholder='Simbolo' name='symbol' options={[{label:"USD", value:"USD"}]} value={form.symbol} onChange={handleChange} error={!!errors.symbol} helperText={errors.symbol} fullWidth/>
                </Grid>
                <Grid item size={12}>
                    <TextField placeholder='Cambio' name='cambio' type='number' InputProps={{startAdornment: <InputAdornment position="start">RD$</InputAdornment>,endAdornment: <InputAdornment position="end">DOP</InputAdornment>}} value={form.cambio} onChange={handleChange} error={!!errors.cambio} helperText={errors.cambio} fullWidth/>
                </Grid>
            </Grid>

        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose} color="inherit">
          Cancelar
        </Button>
        <Button onClick={handleSubmit} variant="contained" color="primarybutton" sx={{fontWeight:"bold"}}>
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
